import { Product } from '../types';

// Vanilla Products
export const vanillaProducts: Product[] = [
  {
    id: 'vanilla-grade-a-gourmet',
    name: 'Vanille Grade A Gourmet',
    category: 'vanilla',
    grade: 'A',
    specifications: [
      { name: 'Vanilline', value: '>1.8', unit: '%' },
      { name: 'Humidité', value: '30', unit: '%' },
      { name: 'Longueur', value: '16-18', unit: 'cm' },
      { name: 'Aspect', value: 'Brillant, très souple' },
      { name: 'Origine', value: 'SAVA, Madagascar' }
    ],
    images: ['/assets/vanilla_GradeA_gourmet.jpeg', '/assets/vanilla_GradeA_TK.jpeg', '/assets/vanilla_branded_pack.jpeg'],
    image: '/assets/vanilla_GradeA_gourmet.jpeg',
    description: {
      fr: 'Notre vanille Grade A Gourmet représente l\'excellence absolue. Sélectionnée parmi les plus belles gousses, elle révèle des arômes d\'une intensité exceptionnelle avec plus de 1.8% de vanilline naturelle.',
      en: 'Our Grade A Gourmet vanilla represents absolute excellence. Selected from the finest pods, it reveals aromas of exceptional intensity with over 1.8% natural vanillin.'
    }
  },
  {
    id: 'vanilla-grade-a-tk',
    name: 'Vanille Grade A TK',
    category: 'vanilla',
    grade: 'A',
    specifications: [
      { name: 'Vanilline', value: '>1.5', unit: '%' },
      { name: 'Humidité', value: '30', unit: '%' },
      { name: 'Longueur', value: '14-16', unit: 'cm' },
      { name: 'Aspect', value: 'Brillant, souple' },
      { name: 'Origine', value: 'SAVA, Madagascar' }
    ],
    images: ['/assets/vanilla_GradeA_TK.jpeg', '/assets/vanilla_GradeA_gourmet.jpeg', '/assets/vanilla_branded_pack.jpeg'],
    image: '/assets/vanilla_GradeA_TK.jpeg',
    description: {
      fr: 'Notre vanille Grade A TK offre une qualité premium avec des arômes riches et complexes, parfaite pour les applications gastronomiques exigeantes.',
      en: 'Our Grade A TK vanilla offers premium quality with rich and complex aromas, perfect for demanding gastronomic applications.'
    }
  },
  {
    id: 'vanilla-grade-b-standard',
    name: 'Vanille Grade B Standard',
    category: 'vanilla',
    grade: 'B',
    specifications: [
      { name: 'Vanilline', value: '>1.2', unit: '%' },
      { name: 'Humidité', value: '30', unit: '%' },
      { name: 'Longueur', value: '12-14', unit: 'cm' },
      { name: 'Aspect', value: 'Souple, légèrement ridée' },
      { name: 'Origine', value: 'SAVA, Madagascar' }
    ],
    images: ['/assets/vanilla_GradeB_RougeUS.jpeg', '/assets/vanilla_GradeB_RougeEU.jpeg', '/assets/vanilla_packed_plastic.jpeg'],
    image: '/assets/vanilla_GradeB_RougeUS.jpeg',
    description: {
      fr: 'Notre vanille Grade B Standard offre un excellent rapport qualité-prix pour l\'industrie alimentaire, conservant toute l\'authenticité du terroir malgache.',
      en: 'Our Grade B Standard vanilla offers excellent value for the food industry, retaining all the authenticity of Malagasy terroir.'
    }
  },
  {
    id: 'vanilla-grade-c',
    name: 'Vanille Grade C',
    category: 'vanilla',
    grade: 'C',
    specifications: [
      { name: 'Vanilline', value: '>1.0', unit: '%' },
      { name: 'Humidité', value: '30', unit: '%' },
      { name: 'Longueur', value: '10-12', unit: 'cm' },
      { name: 'Aspect', value: 'Ridée, cassures possibles' },
      { name: 'Usage', value: 'Extraction industrielle' }
    ],
    images: ['/assets/vanilla_gradeC_alt1.jpeg', '/assets/vanilla_GradeC.jpeg', '/assets/vanilla_gradeC_alt2.jpeg'],
    image: '/assets/vanilla_gradeC_alt1.jpeg',
    description: {
      fr: 'Notre vanille Grade C est spécialement sélectionnée pour l\'extraction et les applications industrielles, idéale pour la production d\'extraits naturels.',
      en: 'Our Grade C vanilla is specially selected for extraction and industrial applications, ideal for producing natural extracts.'
    }
  }
];

// Coffee Products
export const coffeeProducts: Product[] = [
  {
    id: 'coffee-robusta-green-beans',
    name: 'Café Robusta Green Beans',
    category: 'coffee',
    grade: '1',
    specifications: [
      { name: 'Caféine', value: '1.7-3.5', unit: '%' },
      { name: 'Humidité', value: '<12.5', unit: '%' },
      { name: 'Défauts', value: '<5', unit: '%' },
      { name: 'Taille', value: 'Crible 16+' },
      { name: 'Origine', value: 'Hauts plateaux, Madagascar' }
    ],
    images: ['/assets/coffee_cup.jpg', '/assets/coffee.jpeg', '/assets/coffee_robusta_packed.jpeg'],
    image: '/assets/coffee_cup.jpg',
    description: {
      fr: 'Nos grains de café Robusta verts proviennent des hauts plateaux malgaches. Cultivés entre 800 et 1200 mètres d\'altitude, ils développent des notes complexes de chêne et chocolat noir.',
      en: 'Our Robusta green coffee beans come from the Malagasy highlands. Grown between 800 and 1200 meters altitude, they develop complex notes of oak and dark chocolate.'
    }
  }
];

// Spice Products
export const spiceProducts: Product[] = [
  {
    id: 'spices-clove-premium',
    name: 'Girofle Premium',
    category: 'spices',
    specifications: [
      { name: 'Huile essentielle', value: '>15', unit: '%' },
      { name: 'Humidité', value: '<12', unit: '%' },
      { name: 'Eugénol', value: '>85', unit: '%' },
      { name: 'Aspect', value: 'Clous entiers, bruns' },
      { name: 'Origine', value: 'Côte Est, Madagascar' }
    ],
    images: ['/assets/cloves.jpeg', '/assets/clove.jpg'],
    image: '/assets/cloves.jpeg',
    description: {
      fr: 'Nos clous de girofle premium proviennent des plantations de la côte Est. Séchés naturellement au soleil tropical, ils conservent une concentration exceptionnelle en huiles essentielles.',
      en: 'Our premium cloves come from East coast plantations. Naturally sun-dried under tropical skies, they retain exceptional concentration of essential oils.'
    }
  },
  {
    id: 'spices-black-pepper-wild',
    name: 'Poivre Noir Sauvage',
    category: 'spices',
    specifications: [
      { name: 'Pipérine', value: '>5', unit: '%' },
      { name: 'Humidité', value: '<12', unit: '%' },
      { name: 'Huiles volatiles', value: '2-4', unit: '%' },
      { name: 'Aspect', value: 'Grains entiers, noirs' },
      { name: 'Récolte', value: 'Manuelle, sauvage' }
    ],
    images: ['/assets/pepper.jpg', '/assets/poivre.jpg'],
    image: '/assets/pepper.jpg',
    description: {
      fr: 'Notre poivre noir sauvage est récolté à la main dans les forêts primaires. Cette variété endémique développe une intensité aromatique exceptionnelle avec des notes piquantes uniques.',
      en: 'Our wild black pepper is hand-harvested in primary forests. This endemic variety develops exceptional aromatic intensity with unique spicy notes.'
    }
  },
  {
    id: 'spices-cinnamon-tamatave',
    name: 'Cannelle de Tamatave',
    category: 'spices',
    specifications: [
      { name: 'Cinnamaldéhyde', value: '>3', unit: '%' },
      { name: 'Humidité', value: '<12', unit: '%' },
      { name: 'Huiles essentielles', value: '1-4', unit: '%' },
      { name: 'Aspect', value: 'Écorce roulée, dorée' },
      { name: 'Origine', value: 'Région de Tamatave' }
    ],
    images: ['/assets/cannelle.jpg', '/assets/cinnamon_eam.jpg'],
    image: '/assets/cannelle.jpg',
    description: {
      fr: 'Notre cannelle de Tamatave provient des plantations historiques de la côte Est. L\'écorce est délicatement pelée et séchée pour révéler des arômes suaves et épicés.',
      en: 'Our Tamatave cinnamon comes from historic East coast plantations. The bark is delicately peeled and dried to reveal smooth and spicy aromas.'
    }
  }
];

// Cocoa Products
export const cocoaProducts: Product[] = [
  {
    id: 'cocoa-premium-beans',
    name: 'Fèves de Cacao Premium',
    category: 'cocoa',
    specifications: [
      { name: 'Variétés', value: 'Criollo 5%, Trinitario 35%, Forastero 60%' },
      { name: 'Humidité', value: '7-8', unit: '%' },
      { name: 'Taille', value: '90-100 fèves pour 100g' },
      { name: 'Fermentation', value: 'Traditionnelle 6-8 jours' },
      { name: 'Origine', value: 'Sambirano, Madagascar' }
    ],
    images: ['/assets/cocoa_eam.jpg', '/assets/cocoa_beans_sorting.jpeg', '/assets/cocoa_harvest.jpeg'],
    image: '/assets/cocoa_eam.jpg',
    description: {
      fr: 'Nos fèves de cacao premium proviennent de la vallée du Sambirano. Fermentées selon les méthodes traditionnelles, elles développent des arômes complexes de fruits rouges et d\'épices.',
      en: 'Our premium cocoa beans come from the Sambirano valley. Fermented using traditional methods, they develop complex aromas of red fruits and spices.'
    }
  }
];

// Essential Oils Products (sample - you can add more)
export const essentialOilProducts: Product[] = [
  {
    id: 'essential-oil-ravintsara',
    name: 'HE Ravintsara',
    category: 'essential-oils',
    specifications: [
      { name: 'Pureté', value: '100', unit: '%' },
      { name: 'Extraction', value: 'Distillation vapeur' },
      { name: 'Origine', value: 'Madagascar' },
      { name: 'Certification', value: 'Bio' }
    ],
    images: ['/assets/vanilla_farmers.jpeg'],
    image: '/assets/vanilla_farmers.jpeg',
    description: {
      fr: 'Notre huile essentielle de Ravintsara est extraite des feuilles fraîches par distillation à la vapeur. Reconnue pour ses propriétés exceptionnelles.',
      en: 'Our Ravintsara essential oil is extracted from fresh leaves by steam distillation. Recognized for its exceptional properties.'
    }
  },
  {
    id: 'essential-oil-ylang-ylang',
    name: 'HE Ylang Ylang',
    category: 'essential-oils',
    specifications: [
      { name: 'Pureté', value: '100', unit: '%' },
      { name: 'Grade', value: 'Extra' },
      { name: 'Extraction', value: 'Distillation vapeur' },
      { name: 'Origine', value: 'Nosy Be, Madagascar' }
    ],
    images: ['/assets/vanilla_flowers.jpeg'],
    image: '/assets/vanilla_flowers.jpeg',
    description: {
      fr: 'Notre huile essentielle d\'Ylang Ylang Extra provient des fleurs fraîches de Nosy Be. Son parfum envoûtant en fait un trésor de l\'aromathérapie.',
      en: 'Our Ylang Ylang Extra essential oil comes from fresh flowers from Nosy Be. Its captivating fragrance makes it a treasure of aromatherapy.'
    }
  }
];

// Legumes Products
export const legumeProducts: Product[] = [
  {
    id: 'legumes-beans-lentils',
    name: 'Haricots et Lentilles Variés',
    category: 'legumes',
    specifications: [
      { name: 'Variétés', value: 'Haricots rouges, blancs, lentilles' },
      { name: 'Humidité', value: '<14', unit: '%' },
      { name: 'Pureté', value: '>98', unit: '%' },
      { name: 'Origine', value: 'Hauts plateaux, Madagascar' }
    ],
    images: ['/assets/vanilla_packed.jpeg'],
    image: '/assets/vanilla_packed.jpeg',
    description: {
      fr: 'Nos légumineuses proviennent des hauts plateaux malgaches. Cultivées selon les méthodes traditionnelles, elles offrent une qualité nutritionnelle exceptionnelle.',
      en: 'Our legumes come from the Malagasy highlands. Grown using traditional methods, they offer exceptional nutritional quality.'
    }
  }
];

export const products: Product[] = [
  ...vanillaProducts,
  ...coffeeProducts,
  ...spiceProducts,
  ...cocoaProducts,
  ...essentialOilProducts,
  ...legumeProducts
];